// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"541bb064","316":"00c3dc61","453":"d212c517","523":"a2a537f5","941":"d8b1696d"}[chunkId] + ".chunk.js";
};